var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['button-container', { 'button-hidden': !_vm.showButton }]},[_c('BaseButton',{staticClass:"sticky-button full-width",class:{ larger: !_vm.isMobile },attrs:{"link":_vm.content.ButtonLink,"is-external":true}},[_vm._v(_vm._s(_vm.content.ButtonText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }